<template>
  <div class="m-24">
    <div class="max-w-[1216px] flex flex-col justify-self-center mx-auto">
      <poppins-breadcrumb
        v-if="showBreadcrumb"
        to="/account/seekers/dashboard"
        header="Back to Getting Started"
        class="mt-[40px] max-w-max"
      />
      <BGCHeader class="mt-[40px]" :userType="userType" />
      <BGCCards class="my-40" :bgcPricing="bgcPricing" :isLoadingPrices="isLoadingPrices" />
      <BGCSearchBanner class="my-40" />
      <BGCQuestions class="my-40" />
      <BGCFooter class="my-40" />
    </div>
  </div>
</template>

<script lang="ts">
import BGCHeader from './components/BGCHeader.vue';
import BGCCards from './components/BGCCards.vue';
import BGCQuestions from './components/BGCQuestions.vue';
import BGCSearchBanner from './components/BGCSearchBanner.vue';
import BGCFooter from './components/BGCFooter.vue';
import Breadcrumb from '@/components/breadcrumb/Breadcrumb.vue';
import { Account } from '@/models/account';
import { BGC_PRICING_QUERY } from '@/graphql/background_checks/queries';

export default {
  name: 'BGCOverview',
  components: {
    BGCHeader,
    BGCCards,
    BGCQuestions,
    BGCSearchBanner,
    BGCFooter,
    PoppinsBreadcrumb: Breadcrumb,
  },
  data() {
    return {
      isLoadingPrices: true,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/getAccount'] as Account;
    },
    userType() {
      return {
        isCorporate: this.account.isCorporate(),
        isBasic: this.account.isBasic(),
        isPremium: this.account.isPremium(),
      };
    },
    showBreadcrumb() {
      return this.$route.query.from === 'checklist';
    },
  },
  apollo: {
    bgcPricing: {
      query: BGC_PRICING_QUERY,
      result() {
        this.isLoadingPrices = false;
      },
    },
  },
};
</script>
